module.exports = __webpack_public_path__ + "media/boop.d1719c69.mp3";